import React, { useEffect, useState } from "react";
import { PickersActionBar, PickersActionBarProps } from "@mui/x-date-pickers";
import { Box, FormHelperText, Typography } from "@mui/material";
import { Moment } from "moment";

interface CustomActionBarProps {
  onAccept: (date: Moment | null) => void;
  onClear: PickersActionBarProps["onClear"];
  //   onSetToday: PickersActionBarProps["onSetToday"];
  onCancel: PickersActionBarProps["onCancel"];
  selectedDate: Moment | null;
}

const CustomActionBar: React.FC<CustomActionBarProps> = ({
  onAccept,
  onClear,
  //   onSetToday,
  onCancel,
  selectedDate,
}) => {
  const [showError, setShowError] = useState(false);

  const hasValidTime = selectedDate !== null && selectedDate.isValid();

  useEffect(() => {
    if (hasValidTime) {
      setShowError(false);
    }
  }, [selectedDate]);

  const handleAccept = () => {
    if (!hasValidTime) {
      setShowError(true);
      return;
    }

    setShowError(false);
    onAccept(selectedDate);
  };

  const handleClear = () => {
    setShowError(false);
    onClear?.();
  };
  return (
    <>
      <Box
        sx={{
          minHeight: "24px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pt: 1,
        }}
      >
        {showError && (
          <FormHelperText
            error
            role="alert"
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: "12px",
              margin: 0,
            }}
          >
            Please select a date and time to proceed.
          </FormHelperText>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          padding: 1,
          borderTop: "none",
        }}
      >
        <PickersActionBar
          actions={["clear", "accept"]}
          // onAccept={() => onAccept(selectedDate)}
          // onClear={onClear}
          onAccept={handleAccept}
          onClear={handleClear}
          onSetToday={() => {}}
          onCancel={onCancel}
        />
      </Box>
    </>
  );
};

export default CustomActionBar;
